import { ExcelTemplate } from '../../../interfaces';
import * as XLSX from 'xlsx-js-style';
import { getPreparedData } from './mapping';
import { setColumnWidth, setRowHeight, withHeaderStyling } from '../../../utils';
import { fitToColumn } from '../utils';
import { ShownPeriodsData } from 'src/app/domain/financial-statement/utils/common/utilityClasses';
import { FinancialStatementPart } from 'src/app/domain/financial-statement/models/common/FinancialStatementPart';
import { CellObject } from 'xlsx-js-style';
import { PL_TABS } from '../../../../financial-statement/component/pl-page/pl-page.component';

export class ProfitAndLossTemplate implements ExcelTemplate {
  export(data: PlExcelExportData): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  getSheet(exportExcelData: PlExcelExportData): XLSX.WorkSheet {
    const preparedData = getPreparedData(exportExcelData);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    setColumnWidth(sheet, 0, 30);
    setRowHeight(sheet, 0, 30);

    preparedData.forEach((row, index) => {
      const cell: Partial<CellObject> = row[0];
      if (cell.v === 'Profits' || cell.v === 'Losses') {
        setRowHeight(sheet, index, 30);
      }
    });
    return withHeaderStyling(sheet);
  }
}

export interface PlExcelExportData {
  shownPeriodsData: ShownPeriodsData;
  parts: FinancialStatementPart[];
  selectedPeriod: Date;
  periodType: typeof PL_TABS[number];
}
